import React from "react";
import { ChevronLeft, ChevronRight, List, Columns3 } from "lucide-react";

export const isoDay = (d) => d.toLocaleDateString("sv-SE");
export const mondayOf = (iso) => {
  const d = iso ? new Date(`${iso}T12:00:00`) : new Date();
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return isoDay(d);
};
export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  return isoDay(d);
};
export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));
export const fmtLong = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "long" });
export const defaultView = (key) => localStorage.getItem(key) || (window.innerWidth < 1024 ? "lista" : "settimana");

export const ViewToggle = ({ view, onChange, gridDisabled = false }) => {
  const btn = (v, Icon, label) => {
    const on = view === v;
    return (
      <button onClick={() => onChange(v)} disabled={v === "settimana" && gridDisabled} data-testid={`agenda-view-${v}`}
        title={v === "settimana" && gridDisabled ? "Disponibile senza filtro Dal/Al" : label}
        className="px-3 py-2 text-xs font-semibold flex items-center gap-1 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        style={{ background: on ? "var(--primary)" : "#fff", color: on ? "#fff" : "inherit" }}>
        <Icon className="w-3.5 h-3.5" /> {label}
      </button>
    );
  };
  return (
    <div className="inline-flex rounded-md border overflow-hidden" style={{ borderColor: "var(--border)" }}>
      {btn("settimana", Columns3, "Settimana")}
      {btn("lista", List, "Lista")}
    </div>
  );
};

export const WeekNav = ({ label, onPrev, onNext, onToday, disabled = false, children }) => (
  <div className="card-shell p-3 flex flex-wrap items-center gap-2">
    <button onClick={onPrev} disabled={disabled} className="btn-secondary text-xs disabled:opacity-40" data-testid="agenda-prev-week"><ChevronLeft className="w-4 h-4" /></button>
    <button onClick={onToday} disabled={disabled} className="btn-secondary text-xs disabled:opacity-40" data-testid="agenda-today">Oggi</button>
    <button onClick={onNext} disabled={disabled} className="btn-secondary text-xs disabled:opacity-40" data-testid="agenda-next-week"><ChevronRight className="w-4 h-4" /></button>
    <div className="font-bold ml-2" style={{ fontFamily: "Manrope" }} data-testid="agenda-week-range">{label}</div>
    <div className="ml-auto flex gap-3 text-xs" data-testid="agenda-counters">{children}</div>
  </div>
);
